export default {"src":"/_next/static/media/rCareNew.77982c30.svg","height":34,"width":34};